import z from 'zod';

import { LanguageCode } from '../../../brand/brand';
import { makeEndpoint } from '../../../common';

const TranslatedNameSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const ListingV3I18nLanguageSchema = z.object({
  title: z.string().optional(),
  summary: z.string().optional(),
  description: z.string().optional(),
  headline: z.string().optional(),
  customCallToAction: z.string().optional(),
  category: TranslatedNameSchema.optional(),
  vibes: z.array(TranslatedNameSchema).optional(),
  updatedAt: z.string().datetime().optional(),
});

export const GetListingV3I18nPublicResponseSchema = z.object({
  listingId: z.string(),
  default: z.nativeEnum(LanguageCode),
  translations: z.record(z.string(), ListingV3I18nLanguageSchema),
});

export type GetListingV3I18nPublicResponse = z.infer<typeof GetListingV3I18nPublicResponseSchema>;

export const GetListingV3I18nPublicEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, listingId }: { brandId: string; listingId: string }) => `v3/brands/${brandId}/listings/${listingId}/i18n`,
  responseSchema: GetListingV3I18nPublicResponseSchema,
  requestSchema: z.void(),
});
